import { canSeeOwnWorkCalendar } from '../../features/profile/entityPermissions';
import { SETTINGS_TAB_VISIBILITY, VisibilityAwareNavigationItem } from '../../features/profile/navigationVisibility';
import { Profile } from '../../features/profile/types';
import { isSectionVisible, SectionVisibilityConfig } from '../../helpers/permissionHelper';
import { NAVIGATION_ROUTES } from '../../routes/NavigationRoute';

export type SettingsTabKey = 'preferences' | 'integrations' | 'earlyAccess' | 'calendar';

export interface SettingsTabDefinition extends VisibilityAwareNavigationItem {
    key: SettingsTabKey;
    name: string;
    route: string;
    visibility: SectionVisibilityConfig;
}

export const SETTINGS_TABS: SettingsTabDefinition[] = [
    { key: 'preferences', name: 'Preferences', visibility: SETTINGS_TAB_VISIBILITY.preferences, route: NAVIGATION_ROUTES.SETTINGS_PREFERENCES },
    { key: 'earlyAccess', name: 'Early access', visibility: SETTINGS_TAB_VISIBILITY.earlyAccess, route: NAVIGATION_ROUTES.SETTINGS_EARLY_ACCESS },
    { key: 'calendar', name: 'Work calendar', visibility: SETTINGS_TAB_VISIBILITY.calendar, route: NAVIGATION_ROUTES.SETTINGS_CALENDAR },
];

export function getVisibleSettingsTabs(profile: Profile | null | undefined): SettingsTabDefinition[] {
    return SETTINGS_TABS.filter((tab) => {
        if (tab.key === 'calendar') {
            return canSeeOwnWorkCalendar(profile);
        }

        return isSectionVisible(profile, tab.visibility);
    });
}
